import Index from '@/components/transports/index'
import Details from '@/components/transports/Details'
import TransportLicense from '@/components/transports/print/TransportLicense'
import LicenseRecord from '@/components/transports/print/LicenseRecord'
import TransportRecord from '@/components/transports/print/TransportRecord'

export default {
  name: 'transports',
  path: 'transports',
  redirect: '/transports/index',
  meta: { auth: { statuses: ['courierDataApproved'] } },
  component: {
    render (c) { return c('router-view') }
  },
  children: [
    {
      path: 'index',
      meta: { auth: { statuses: ['courierDataApproved'] } },
      component: Index
    },
    {
      path: ':id',
      meta: { auth: { statuses: ['courierDataApproved'] } },
      component: Details,
      props: true
    },
    {
      path: ':transportId/transport-license',
      meta: { print: true, auth: { statuses: ['courierDataApproved'] } },
      component: TransportLicense,
      props: true
    },
    {
      path: ':transportId/licenses/:licenseId',
      meta: { print: true, auth: { statuses: ['courierDataApproved'] } },
      component: TransportLicense,
      props: true
    },
    {
      path: ':transportId/licenses/:licenseId/license-record',
      meta: { print: true, auth: { statuses: ['courierDataApproved'] } },
      component: LicenseRecord,
      props: true
    },
    {
      path: ':transportId/transport-record',
      meta: { print: true, auth: { statuses: ['courierDataApproved'] } },
      component: TransportRecord,
      props: true
    }
  ]
}
